import { withI18n } from 'panda-i18n';
import { componentName } from './constant';
import locale from '@/locale';
import CnResultView from './cn-result-view';
export const CnResult = withI18n(CnResultView, {
    componentName,
    locale,
});
